/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const LassoSelectIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Lasso Select',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 20 20"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="m12.99854,11.65039c-.61084.2998-1.25684.52246-1.91797.66309-1.21332.25476-2.45441.26172-3.66699.06653.03772-.18567.05811-.37756.05811-.57434,0-1.58887-1.29248-2.88086-2.88135-2.88086-.73425,0-1.39801.28442-1.90735.73828-.03058-.08862-.06946-.17407-.09216-.26562-.54053-2.19727,1.39795-4.73242,4.6084-6.02832.38428-.15527.56982-.5918.41455-.97656-.15479-.38379-.59229-.57031-.97607-.41406C2.66553,3.58203.40234,6.78027,1.13428,9.75684c.12878.51782.34961,1.00012.64154,1.44409-.04193.19531-.06635.39697-.06635.60474,0,1.58887,1.29248,2.88086,2.88086,2.88086.14825,0,.29059-.02197.43286-.0437.17236.28589.3678.54053.5437.7644.26318.33594.51221.65234.52148.9082.02051.2832-.07031.55762-.25586.77246s-.44385.34473-.72754.36523c-.08838.00586-.17432.00293-.2583-.0127-.40918-.06445-.7959.20215-.86719.61035s.20215.79688.61035.86816c.14355.02441.28955.03711.43604.03711.0625,0,.12549-.00195.18799-.00684.68311-.0498,1.30566-.3623,1.75342-.88086.44775-.51758.66699-1.17871.61865-1.83398-.0249-.71582-.45752-1.2666-.83936-1.75293-.13-.16577-.24164-.31519-.33917-.4585.09601-.07886.19025-.15833.27533-.24878,1.54742.31934,3.14771.33472,4.70789.00708.78369-.16699,1.54639-.43066,2.26807-.7832.37158-.18262.52588-.63184.34326-1.00391-.18115-.37109-.63037-.52344-1.00342-.34375Zm-9.78906.15527c0-.76172.61963-1.38086,1.38086-1.38086.76172,0,1.38135.61914,1.38135,1.38086,0,.078-.01056.15332-.02307.22778-.10181-.03259-.20703-.05029-.30798-.08618-.19824-.06836-.41797-.05371-.60352.04492-.18604.09961-.32178.27246-.37402.47656-.06543.25549-.08282.49097-.0802.71704-.75769-.00415-1.37341-.62097-1.37341-1.38013Z"
      fill="currentColor"
    />
    <path
      d="m16.53467,9.41406c-.26855.33008-.61963.58887-1.01416.74902-.38428.15625-.56885.59375-.41309.97754.11816.29102.39893.46777.69531.46777.09375,0,.18896-.01758.28125-.05469.62842-.25488,1.18604-.66699,1.61377-1.19238.26172-.32129.21338-.79395-.10791-1.05566-.32129-.26074-.79346-.21191-1.05518.1084Z"
      fill="currentColor"
    />
    <path
      d="m18.47754,4.69922c-.23438-.3418-.70117-.42578-1.04297-.19336-.34131.23438-.42773.70117-.19336,1.04297.22705.33008.30957.74414.22705,1.13477-.08545.40527.17383.80371.5791.88867.05225.01172.104.0166.15576.0166.34668,0,.6582-.24219.73291-.59473.16699-.79199,0-1.62793-.4585-2.29492Z"
      fill="currentColor"
    />
    <path
      d="m15.93799,3.45508c.24658,0,.48828-.12109.63135-.34473.22412-.34863.12305-.8125-.2251-1.03613-.56055-.36035-1.17578-.60742-1.82812-.73438-.40088-.08105-.7998.1875-.87939.59277-.0791.40723.18652.80078.59326.87988.46484.08984.90332.2666,1.30273.52344.12549.08105.26611.11914.40527.11914Z"
      fill="currentColor"
    />
    <path
      d="m9.68506,2.69336c.03564,0,.07178-.00195.10791-.00781.5083-.07324,1.02686-.12109,1.54053-.14258.41357-.0166.73535-.36621.71826-.78027-.01758-.41406-.35645-.77441-.78076-.71777-.56396.02344-1.1333.07617-1.69189.15625-.40967.05859-.69434.43945-.63525.84863.05371.37402.37451.64355.74121.64355Z"
      fill="currentColor"
    />
  </svg>`;
};
